const baseStyle = {
    textAlign: 'center',
    border: '1px solid transparent',
    margin: 'auto',
    textTransform: "uppercase",
    fontWeight: 400,
    padding: "0 1.4em",
}

const variantRegular = {
    bg: "primary.500",
    fontSize: "sm"
}

const variantRegularNo = {
    ...variantRegular,
    bg: "negative.500"
}

const variantSecondary = {
    fontSize: "sm",
    bg: "transparent",
    border: "1px solid",
    borderColor: "primary.500",
    color: "primary.500",
    _hover: {
        bg: "primary.500",
        color: "white"
    }
}

const variantSecondaryNo = {
    ...variantSecondary,
    borderColor: "negative.500",
    color: "negative.500",
    _hover: {
        ...variantSecondary._hover,
        bg: "negative.500",
    }
}

const variants = {
    regular: variantRegular,
    regularNo: variantRegularNo,
    secondary: variantSecondary,
    secondaryNo: variantSecondaryNo,
}

const defaultProps = {
    font: 'heading',
    variant: 'regular',
}

export default {
    baseStyle,
    variants,
    defaultProps,
};
